import { Button } from '@unified-checkout/design-system';
import { ArrowRight } from '@unified-checkout/design-system/icons/index';
import { BackButton } from 'apps/customer/src/components';
import { FAQS } from 'apps/customer/src/constants';
import { useLiveChat } from 'apps/customer/src/hooks';
import { useNavigate } from 'react-router-dom';

export const CurrentFaq = ({ currentFaq }: { currentFaq: string }) => {
  const navigate = useNavigate();
  const { chatToggler } = useLiveChat();

  const faq = FAQS[+currentFaq - 1];
  const nextFaq = FAQS[+currentFaq];

  return (
    <section className="flex flex-col h-full md:block md:h-auto">
      <BackButton onClick={() => navigate(-1)} />
      <h2 className="page-title !mb-11">{faq.question}</h2>
      <div className="flex flex-col h-full px-2 md:block md:h-auto">
        <p className="text-gray-600 english-body-sm-regular whitespace-pre-line">{faq.answer}</p>
        {nextFaq && (
          <div className="flex items-center gap-1 mt-auto mb-auto md:mt-11 md:mb-8 [&_svg]:size-4 [&_path]:fill-primary-600">
            <Button
              text={nextFaq.question}
              size="sm"
              variant="link"
              color="primary"
              trailingIcon={ArrowRight}
              onClickHandler={() => navigate(`?faq=${+currentFaq + 1}`)}
            />
          </div>
        )}
      </div>
      <div className="flex items-center justify-center gap-1 pt-3 mx-2 mt-auto mb-16 text-gray-200 border-t md:justify-normal md:w-[268px]">
        <p className="text-gray-700 english-utility-helper-text-regular">
          Still need help?
        </p>
        <Button
          text="Live chat"
          color="primary"
          size="sm"
          variant="link"
          onClickHandler={() => chatToggler()}
        />
      </div>
    </section>
  );
};
